import React from "react";
import styles from "./pagenotfound.module.css";
import { Link } from "react-router-dom";
import { Divider } from "antd";

export default function Unauthorized() {
  return (
    <div className={styles.maindiv}>
      <div className={styles.firstdiv}>
        <span className={styles.digitsize}>403</span>
      </div>

      <div>
        <Divider
          type="vertical"
          style={{
            height: "100px",
            fontSize: "20px",
            fontWeight: "bold",
            backgroundColor: "black",
          }}
        />
      </div>

      <div className={styles.seconddiv}>
        <span className={styles.fistpara}>SORRY !</span>
        <span className={styles.secondpara}>The Page you are looking For </span>
        <span>is not authorized.</span>Please contact to admin
        <div className={styles.redirectclass}>
          <span>
            <Link to={"/"}>Go to Home Page</Link>
          </span>
        </div>
      </div>
    </div>
  );
}
